import axios from 'axios';
import i18n from '@/i18n';
import logger from '@/lib/logger';

/**
 * First-party product events.
 *
 * The server-side `product_events` collection is the authoritative dataset for
 * product adoption; PostHog / GA4 receive the same event only when the site's
 * own analytics snippet is present (that snippet carries the consent handling —
 * this helper never bypasses it).
 *
 * Only non-identifying product context is ever sent: no email, organisation,
 * scenario name, decision text, financial value or raw share token. The backend
 * re-validates and strips anything outside its allow-list.
 */
const SAFE_KEYS = ['scenario_count', 'has_selected_scenario', 'has_decision_note',
                   'expiry_days', 'version', 'source', 'share_ref', 'group_ref', 'placement',
                   // M0 evidence keys. `group_id` is hashed server-side into
                   // `group_ref` and is never stored raw.
                   'edit_count', 'interaction', 'group_id'];

export function trackProductEvent(event, context = {}, options = {}) {
  const safe = {};
  SAFE_KEYS.forEach(key => {
    if (context[key] !== undefined && context[key] !== null) safe[key] = context[key];
  });

  axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/events`, {
    event,
    locale: (options.locale || i18n.language || 'en').slice(0, 2),
    context: safe,
  }).catch(err => logger.debug('[analytics] event not recorded:', err?.message || err));

  // Acquisition events stay first-party: third-party SDKs may auto-enrich payloads.
  if (options.firstPartyOnly) return;
  try {
    window.posthog?.capture?.(event, safe);
    window.gtag?.('event', event, safe);
  } catch (err) {
    logger.debug('[analytics] client tracker unavailable:', err?.message || err);
  }
}
